/* Goldgums-winkelwagenpagina: aantallen, verwijderen, kortingscode, toevoegen — zonder herladen. */
(() => {
  if (window.ggCartPageInit) return; window.ggCartPageInit = true;
  const sel = '[data-gg-cart-page]';
  const root = () => document.querySelector(sel);
  const sectionId = () => root()?.dataset.sectionId;
  const busy = (on) => root()?.classList.toggle('is-busy', on);
  const msg = (t) => { const m = root()?.querySelector('[data-gg-discount-msg]'); if (m) m.textContent = t || ''; };

  const render = (json) => {
    const html = json && json.sections && json.sections[sectionId()];
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector(sel);
      if (fresh) root().replaceWith(fresh);
    } else { location.reload(); return; }
    const bubble = json.sections['cart-icon-bubble'];
    const target = document.getElementById('cart-icon-bubble');
    if (bubble && target) target.innerHTML = new DOMParser().parseFromString(bubble, 'text/html').querySelector('.shopify-section')?.innerHTML || target.innerHTML;
  };
  const post = async (url, body) => {
    busy(true);
    try {
      const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: [sectionId(), 'cart-icon-bubble'], sections_url: location.pathname }) });
      const j = await r.json();
      if (j.status && j.description) { msg(j.description); return null; }
      render(j); return j;
    } catch (_) { msg('Er ging iets mis. Probeer het opnieuw.'); return null; }
    finally { busy(false); }
  };
  const change = (line, quantity) => post('/cart/change.js', { line: Number(line), quantity: Math.max(0, Number(quantity) || 0) });

  document.addEventListener('click', async (e) => {
    if (!e.target.closest(sel)) return;
    const q = e.target.closest('[data-gg-line-qty]');
    if (q) { e.preventDefault(); return change(q.dataset.ggLineQty, q.dataset.qty); }
    const rm = e.target.closest('[data-gg-line-remove]');
    if (rm) { e.preventDefault(); return change(rm.dataset.ggLineRemove, 0); }
    if (e.target.closest('[data-gg-discount-apply]')) {
      const input = root().querySelector('[data-gg-discount-input]');
      const code = input.value.trim(); if (!code) return;
      const current = [...root().querySelectorAll('[data-gg-discount-remove]')].map((b) => b.dataset.ggDiscountRemove);
      const j = await post('/cart/update.js', { discount: [...current, code].join(',') });
      if (j && Array.isArray(j.discount_codes) && !j.discount_codes.some((d) => d.code.toLowerCase() === code.toLowerCase() && d.applicable)) msg(`Code "${code}" is niet geldig voor deze winkelwagen.`);
      return;
    }
    const dr = e.target.closest('[data-gg-discount-remove]');
    if (dr) {
      const rest = [...root().querySelectorAll('[data-gg-discount-remove]')].map((b) => b.dataset.ggDiscountRemove).filter((c) => c !== dr.dataset.ggDiscountRemove);
      return post('/cart/update.js', { discount: rest.join(',') });
    }
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest(`${sel} [data-gg-line-input]`);
    if (i) change(i.dataset.ggLineInput, i.value);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.matches(`${sel} [data-gg-discount-input]`)) { e.preventDefault(); root().querySelector('[data-gg-discount-apply]').click(); }
  });
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest(`${sel} [data-gg-cart-add]`);
    if (!f) return;
    e.preventDefault();
    busy(true);
    try {
      const body = new FormData(f);
      body.append('sections', [sectionId(), 'cart-icon-bubble'].join(','));
      body.append('sections_url', location.pathname);
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
      const j = await r.json();
      if (j.status) { msg(j.description || 'Toevoegen is niet gelukt.'); return; }
      render(j);
    } catch (_) { msg('Toevoegen is niet gelukt.'); }
    finally { busy(false); }
  }, true);
})();